import { getCssVar } from "../types/theme";

export const getTextStyle = (card: any) => {
  if (card.isBestValue) {
    return {
      color: getCssVar("color_text_white"),
    };
  }
  return {};
};

export const getBackgroundStyle = (card: any) => {
  if (card.isBestValue) {
    return {
      background: getCssVar(
        "color_best_value_picker_card",
        "linear-gradient(180deg, #666 0%, #000 100%)"
      ),
    };
  }
  return {};
};

export const getHeaderStyle = (card: any, allCards: any[]) => {
  if (card.isBestValue) {
    return {
      color: getCssVar("color_heading"),
      backgroundColor: getCssVar("color_accent_1"),
    };
  } else if (isBasicProduct(card, allCards)) {
    return {
      backgroundColor: "#919191",
    };
  }
  return {};
};

const isBasicProduct = (card: any, allCards: any[]) => {
  const price = parseFloat(card.price);
  return (
    !card.isBestValue &&
    allCards.every(
      (otherCard) =>
        otherCard.isBestValue || parseFloat(otherCard.price) <= price
    )
  );
};
